// TODO: add drawer animation
// TODOx2: Asked design an there is no concrete transition. Moving to conditional
// rendering to stop both sys and tag views showing at same time. Need to revisit

import styled from 'styled-components';

import { customScrollPrimary } from '../../../../app/global-styles';

import { highlightCss, navIconCss, rowSharedCss } from './shared-styles';

import { colors, Size, text } from '@controlrooms/design-tokens';

// when transition provided.
export const TagViewContainer = styled.div`
  align-items: stretch;
  background-color: ${({ theme }) => theme.sidebar.folders.backgroundColor};
  display: flex;
  flex-flow: column nowrap;
  height: calc(100vh - 150px);
  justify-content: flex-start;
  overflow-y: auto;

  ${highlightCss}

  ${customScrollPrimary} 
  
  &.expanded {
    .select-root {
      display: flex;
    }
  }

  .section-header-label {
    align-items: center;
    display: flex;
    flex-flow: row nowrap;
    justify-content: flex-start;
    flex-grow: 1;

    &:hover {
      .name,
      .description {
        color: #ffffff;
      }
    }

    &:hover .name {
      color: ${colors.k[90]};
      font-size: 11px;
      font-weight: 700;
    }

    .description {
      color: ${colors.k[90]};
      font-size: 9px;
      font-family: 'Open Sans', sans-serif;
      font-weight: 400;
      margin-right: 12px;
    }
  }

  .select-root {
    align-items: center;
    display: none;
    flex-flow: row nowrap;
    justify-content: flex-start;

    .sub-title {
      margin-left: 0;
    }
  }

  .sub-system-label {
    display: flex;
    flex: 1;
    .search-mode {
      display: flex;
      flex: 1;
      align-items: center;
      min-width: 0;
      .description {
        flex: 1;
        flex-shrink: 0;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
      .name-wrapper {
        flex: 1;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
      .name {
        max-width: 50%;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
    }
    .description {
      flex-basis: 40px;
      align-self: baseline;
      margin-top: 1px;
    }
  }

  .sub-system-tag-header {
    .arrow-icon {
      margin-right: 3px;
    }

    ${navIconCss}
  }

  .no-tags {
    cursor: initial;
  }

  .tag-check {
    flex: 0 0 12px;
    margin-left: 5px;
    margin-right: 7px;
    visibility: hidden;
    width: 12px;
  }

  .tag-root {
    border-bottom: 1px solid ${colors.k[30]};
  }

  .tag-view-title {
    font-size: 17px;
    font-weight: 400;
    margin: 12px 22px 0;
  }

  &.search-view {
    .gta-wrapper {
      display: flex;
      flex-direction: row-reverse;
    }
  }
`;

export const TagContainer = styled.div`
  align-items: center;
  background-color: ${({ theme }) => theme.sidebar.folders.backgroundColor};
  display: flex;
  grid-template-rows: 50% 50%;
  height: 28px;
  justify-content: flex-start;
  cursor: pointer;
  overflow: hidden;

  &.checked {
    .name > span {
      background-color: ${({ theme }) => theme.tagHeader.tagTitleBackgroundPinned};
    }
  }

  &:hover {
    .description {
      color: ${({ theme }) => theme.tagHeader.tagTitleColorPinned};
    }

    .name > span {
      background-color: ${({ theme }) => theme.tagHeader.tagTitleBackgroundHover};
      color: ${({ theme }) => theme.tagHeader.tagTitleColorPinned};
    }
  }

  ${rowSharedCss}

  .search-mode {
    display: flex;
    flex: 1;
    align-items: center;
    min-width: 0;
    .description {
      flex: 1;
      flex-shrink: 0;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
    .name-wrapper {
      flex: 1;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
    .name {
      max-width: 50%;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }

  .description {
    color: ${({ theme }) => theme.tagHeader.tagTitleColorPinned};
    font-size: ${text.size[Size.DATA_11]};
    font-family: 'Open Sans', sans-serif;
    font-weight: 400;
    flex-grow: 1;
    display: block;
    padding-right: 10px;
  }

  .name {
    align-items: center;
    display: flex;
    height: 28px;
    margin-right: 6px;

    & > span,
    & > mark {
      background-color: ${({ theme }) => theme.tagHeader.tagTitleBackground};
      border-radius: 2px;
      padding: 0.5px 8px;
      font-size: ${text.size[Size.DATA_11]};
      font-family: 'Open Sans', sans-serif;
      font-weight: 400;
      text-align: left;
    }

    & > span {
      color: ${({ theme }) => theme.tagHeader.tagTitleColorPinned};
      flex-shrink: 0;
    }
  }
  > .un-hide-tag-btn {
    background: none;
    border: none;
    padding: 15px;
    margin-left: 5px;

    svg {
      width: 15px;
    }
  }
`;
